import { useEffect, useState } from "react";

export const useDocTitle = (initialTitle) => {
  const [title, setTitle] = useState(initialTitle);
  useEffect(() => {
    document.title = title;
  }, [title]);
  return [title, setTitle];
};

type FormState = {
  data: any;
  errors: any;
};

export const useForm = (
  initial: any
): [
  FormState,
  (key: any, error: any) => void,
  (key: any, value?: any, replace?: string) => (event?: any) => void,
  () => void,
  () => void,
  (initialData: any) => void
] => {
  const [formState, setFormState] = useState<FormState>({
    data: initial,
    errors: {},
  });

  const changeHandler = (key, value, replace) => {
    return (event: any = undefined) => {
      var newValue = value !== undefined ? value : event?.target.value;
      if (replace !== undefined) {
        newValue = newValue.replaceAll(replace, "");
      }

      if (event && event.target.type === "checkbox") {
        newValue = event.target.checked;
      }

      setFormState((prevState) => ({
        ...prevState,
        data: {
          ...prevState.data,
          [key]: newValue,
        },
      }));
    };
  };

  const setError = (key, error) => {
    setFormState((prevState) => ({
      ...prevState,
      errors: {
        ...prevState.errors,
        [key]: error,
      },
    }));
  };

  const resetAll = () => {
    for (let key in formState.data) {
      formState.data[key] = "";
      formState.errors[key] = undefined;
    }
  };

  const resetErrors = () => {
    setFormState((prevState) => ({
      ...prevState,
      errors: {},
    }));
  };

  const setInitialData = (initialData) => {
    setFormState((prevState) => ({
      ...prevState,
      data: {
        ...initialData,
      },
    }));
  };

  return [
    formState,
    setError,
    changeHandler,
    resetAll,
    resetErrors,
    setInitialData,
  ];
};

/**
 * Hook that alerts clicks outside of the passed ref
 */
export function useOutsideAlerter(ref, action: () => void) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        action();
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}
